var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.751717 0.966667C0.820313 0.826669 0.926805 0.708721 1.05909 0.626226C1.19138 0.543732 1.34415 0.5 1.50005 0.5H16.5001C16.6561 0.499892 16.8091 0.543606 16.9415 0.626165C17.0739 0.708723 17.1805 0.826809 17.2491 0.966976C17.3177 1.10714 17.3456 1.26376 17.3295 1.41899C17.3135 1.57422 17.2542 1.72182 17.1584 1.845L11.5001 9.12V14.6667C11.5001 14.8214 11.457 14.9731 11.3756 15.1048C11.2942 15.2364 11.1778 15.3428 11.0394 15.412C10.901 15.4812 10.746 15.5105 10.5919 15.4966C10.4377 15.4827 10.2905 15.4262 10.1667 15.3333L6.83338 12.8333C6.72989 12.7557 6.64588 12.6551 6.58803 12.5393C6.53017 12.4236 6.50005 12.296 6.50005 12.1667V9.11917L0.841717 1.84417C0.746279 1.72106 0.687258 1.57366 0.67135 1.4187C0.655442 1.26375 0.683284 1.10743 0.751717 0.9675V0.966667ZM3.20422 2.16667L7.99088 8.32167C8.10477 8.46792 8.16664 8.64797 8.16672 8.83333V11.75L9.83338 13V8.83333C9.83322 8.64807 9.8948 8.46803 10.0084 8.32167L14.7967 2.16667H3.20422Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.04ac48448b38135d6540d74306b74177.svg";
export { ForwardRef as ReactComponent };